module.exports = __webpack_public_path__ + "img/logo.4c830710.svg";